import UserIcon from "../../assets/img/user-icon.svg";
import useTranslator from "../../hooks/useTranslator";

const PendingSharerPill = ({
  data,
  setFlatmateAddFormModal,
  setSelectedUser,
}) => {
  const { _t } = useTranslator();
  return (
    <>
      <div className="earner-card mb-2">
        <div className="earner-info guarantor-info align-items-center justify-content-between gap-2 d-flex">
          <div className="align-items-center gap-2 d-flex">
            <div className="earner-thumbnail-wrapper">
              <img src={UserIcon} alt="User Icon" />
            </div>
            <h4 className="earner-name">{data?.name}</h4>
          </div>

          <button
            className="btn btngreen completeAddedButton"
            onClick={() => {
              setFlatmateAddFormModal(true);
              setSelectedUser(data);
            }}
          >
            {_t("completeAdding")}
            <div className="completeAddedButtonIcon">
              <img src="/images/arrow-right.svg" alt="" />
            </div>
          </button>
        </div>
      </div>
    </>
  );
};

export default PendingSharerPill;
